import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import Pagination from '../../Pagination';
import './AdminDashboard.css';
import AdminleftSide from './AdminleftSide';
import DashboardLayout from './DashboardLayout';

const BlockAccount = () => {
  const BASE_API_URL = process.env.REACT_APP_API_URL;
  const [userData, setUserData] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(6);
  const [totalPages, setTotalPages] = useState(0);
  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState('asc');

  const handleSort = (column) => {
    let order = 'asc';
    if (sortedColumn === column) {
      order = sortOrder === 'asc' ? 'desc' : 'asc';
    }
    setSortedColumn(column);
    setSortOrder(order);
  };
  useEffect(() => {
    fetchUserData();
  }, [page, pageSize, sortedColumn, sortOrder]);

  const fetchUserData = async () => {
    try {
      const params = {
        page: page,
        size: pageSize,
        sortBy: sortedColumn,
        sortOrder: sortOrder,
      };
      const response = await axios.get(`${BASE_API_URL}/rejectedHrs`, { params });
      setUserData(response.data.content);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error(error);
    }
  };

  const companyName = userData.companyName;
  const handlePageClick = (data) => {
    setPage(data.selected);
  };

  const handlePageSizeChange = (e) => {
    const size = parseInt(e.target.value);
    setPageSize(size);
    setPage(0); // Reset page when page size changes
  };
  const isLastPage = page === totalPages - 1;
  const isPageSizeDisabled = isLastPage;

  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 767);

  useEffect(() => {
    // Update the `isSmallScreen` state based on screen resizing
    const handleResize = () => setIsSmallScreen(window.innerWidth <= 767);

    window.addEventListener('resize', handleResize);

    // Clean up the event listener on component unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <DashboardLayout>

      <div className="main-content">
        {userData.length > 0 ? (
          <>
            <h2>List of Rejected Hr's</h2>
            <div className='table-details-list table-wrapper'>
              <Table hover className='text-center' >
                <thead>
                  <tr>
                    <th onClick={() => handleSort('userName')}>
                      UserName {sortedColumn === 'userName' && (sortOrder === 'asc' ? '▲' : '▼')}
                    </th>
                    <th onClick={() => handleSort('userEmail')}>
                      userEmail {sortedColumn === 'userEmail' && (sortOrder === 'asc' ? '▲' : '▼')}
                    </th>
                    <th onClick={() => handleSort('companyName')}>
                      Company {sortedColumn === 'companyName' && (sortOrder === 'asc' ? '▲' : '▼')}
                    </th>

                  </tr>
                </thead>
                <tbody>
                  {userData.map(user => (
                    <tr key={user.userId}>
                      <td>{user.userName}</td>
                      <td>{user.userEmail}</td>
                      <td>{user.companyName}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </>

        ) : (
          <h4 className='text-center'>Loading.. .!!</h4>
        )}

        {/* Pagination */}

        <Pagination
          page={page}
          pageSize={pageSize}
          totalPages={totalPages}
          handlePageSizeChange={handlePageSizeChange}
          isPageSizeDisabled={isPageSizeDisabled}
          handlePageClick={handlePageClick}
        />
      </div>

    </DashboardLayout>
  )
}

export default BlockAccount
